/*! For license information please see index.js.LICENSE.txt */
(function () {
  var e = {
    184: function _(e, t) {
      var n;
      !function () {
        "use strict";

        var r = {}.hasOwnProperty;

        function o() {
          for (var e = [], t = 0; t < arguments.length; t++) {
            var n = arguments[t];

            if (n) {
              var a = typeof n;
              if ("string" === a || "number" === a) e.push(n);else if (Array.isArray(n)) {
                if (n.length) {
                  var i = o.apply(null, n);
                  i && e.push(i);
                }
              } else if ("object" === a) if (n.toString === Object.prototype.toString) for (var c in n) {
                r.call(n, c) && n[c] && e.push(c);
              } else e.push(n.toString());
            }
          }

          return e.join(" ");
        }

        e.exports ? (o.default = o, e.exports = o) : void 0 === (n = function () {
          return o;
        }.apply(t, [])) || (e.exports = n);
      }();
    },
    28: function _(e, t, n) {
      "use strict";

      n.d(t, {
        Z: function Z() {
          return a;
        }
      });
      var r = n(645),
          o = n.n(r)()(function (e) {
        return e[1];
      });
      o.push([e.id, ".vi__wrapper {\n  position: relative;\n}\n\n.vi {\n  height: 100%;\n  box-sizing: border-box;\n  position: absolute;\n  left: -2000px;\n  opacity: 0;\n  transform: scale(0);\n}\n\n.vi--debug {\n  left: 0;\n  bottom: -70px;\n  opacity: 1;\n  transform: scale(1);\n}\n\n.vi__container {\n  display: flex;\n}\n\n.vi__container--default {\n  height: 50px;\n  width: 300px;\n}\n\n.vi__character {\n  height: 100%;\n  flex-grow: 1;\n  flex-basis: 0;\n  text-align: center;\n}\n\n.vi__character--default {\n  font-size: 36px;\n  line-height: 50px;\n  color: black;\n  background-color: white;\n  margin-left: 8px;\n  border: 1px solid black;\n  cursor: default;\n  user-select: none;\n  box-sizing: border-box;\n}\n\n.vi__character--default:first-child {\n  margin-left: 0;\n}\n\n.vi__character--inactive--default {\n  color: dimgray;\n  background-color: lightgray;\n}\n\n.vi__character--selected--default {\n  outline: 2px solid cornflowerblue;\n  color: cornflowerblue;\n}\n", ""]);
      var a = o;
    },
    645: function _(e) {
      "use strict";

      e.exports = function (e) {
        var t = [];
        return t.toString = function () {
          return this.map(function (t) {
            var n = e(t);
            return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
          }).join("");
        }, t.i = function (e, n, r) {
          "string" == typeof e && (e = [[null, e, ""]]);
          var o = {};
          if (r) for (var a = 0; a < this.length; a++) {
            var i = this[a][0];
            null != i && (o[i] = !0);
          }

          for (var c = 0; c < e.length; c++) {
            var l = [].concat(e[c]);
            r && o[l[0]] || (n && (l[2] ? l[2] = "".concat(n, " and ").concat(l[2]) : l[2] = n), t.push(l));
          }
        }, t;
      };
    },
    703: function _(e, t, n) {
      "use strict";

      var r = n(414);

      function o() {}

      function a() {}

      a.resetWarningCache = o, e.exports = function () {
        function e(e, t, n, o, a, i) {
          if (i !== r) {
            var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
            throw c.name = "Invariant Violation", c;
          }
        }

        function t() {
          return e;
        }

        e.isRequired = e;
        var n = {
          array: e,
          bool: e,
          func: e,
          number: e,
          object: e,
          string: e,
          symbol: e,
          any: e,
          arrayOf: t,
          element: e,
          elementType: e,
          instanceOf: t,
          node: e,
          objectOf: t,
          oneOf: t,
          oneOfType: t,
          shape: t,
          exact: t,
          checkPropTypes: a,
          resetWarningCache: o
        };
        return n.PropTypes = n, n;
      };
    },
    697: function _(e, t, n) {
      e.exports = n(703)();
    },
    414: function _(e) {
      "use strict";

      e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }
  },
      t = {};

  function n(r) {
    var o = t[r];
    if (void 0 !== o) return o.exports;
    var a = t[r] = {
      id: r,
      exports: {}
    };
    return e[r](a, a.exports, n), a.exports;
  }

  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var r in t) {
      n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var r = {};
  (function () {
    "use strict";

    n.r(r), n.d(r, {
      default: function _default() {
        return g;
      }
    });

    var e = require("react");

    var t = n.n(e),
        o = n(184),
        a = n.n(o),
        i = n(697),
        c = n.n(i),
        l = {
      BACKSPACE: 8,
      ARROW_LEFT: 37,
      ARROW_UP: 38,
      ARROW_RIGHT: 39,
      ARROW_DOWN: 40,
      DELETE: 46
    },
        u = n(28),
        s = ["value", "length", "validChars", "placeholder", "autoFocus", "removeDefaultStyles", "debug", "inputProps", "classNames", "onChange", "onFocus", "onBlur"];

    function f(e, t, n) {
      return t in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }

    function p() {
      return (p = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];

          for (var r in n) {
            Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
        }

        return e;
      }).apply(this, arguments);
    }

    function d(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var n = e && ("undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"]);

        if (null != n) {
          var r,
              o,
              a = [],
              i = !0,
              c = !1;

          try {
            for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0) {
              ;
            }
          } catch (e) {
            c = !0, o = e;
          } finally {
            try {
              i || null == n.return || n.return();
            } finally {
              if (c) throw o;
            }
          }

          return a;
        }
      }(e, t) || h(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }

    function h(e, t) {
      if (e) {
        if ("string" == typeof e) return v(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e, t) : void 0;
      }
    }

    function v(e, t) {
      (null == t || t > e.length) && (t = e.length);

      for (var n = 0, r = new Array(t); n < t; n++) {
        r[n] = e[n];
      }

      return r;
    }

    var y = (0, e.forwardRef)(function (n, r) {
      var o = n.value,
          i = n.length,
          c = n.validChars,
          y = n.placeholder,
          g = n.autoFocus,
          b = n.removeDefaultStyles,
          m = n.debug,
          _ = n.inputProps,
          O = n.classNames,
          x = n.onChange,
          S = n.onFocus,
          R = n.onBlur,
          A = function (e, t) {
        if (null == e) return {};

        var n,
            r,
            o = function (e, t) {
          if (null == e) return {};
          var n,
              r,
              o = {},
              a = Object.keys(e);

          for (r = 0; r < a.length; r++) {
            n = a[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
          }

          return o;
        }(e, t);

        if (Object.getOwnPropertySymbols) {
          var a = Object.getOwnPropertySymbols(e);

          for (r = 0; r < a.length; r++) {
            n = a[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
          }
        }

        return o;
      }(n, s),
          w = d((0, e.useState)(""), 2),
          P = w[0],
          j = w[1],
          E = d((0, e.useState)(!1), 2),
          T = E[0],
          C = E[1],
          I = (0, e.useRef)(null);

      (0, e.useEffect)(function () {
        g && I.current.focus();
      }, [g]);

      var k,
          W = function W() {
        I.current.focus();
      },
          N = function N() {
        return null != o ? o : P;
      };

      return t().createElement("div", {
        className: "vi__wrapper"
      }, t().createElement("input", p({
        value: N(),
        onChange: function onChange(e) {
          var t = e.target.value.replace(/\s/g, "");
          RegExp("^[".concat(c, "]{0,").concat(i, "}$")).test(t) && (x && (null == x || x(t)), j(t));
        },
        ref: function ref(e) {
          I.current = e, "function" == typeof r ? r(e) : r && (r.current = e);
        },
        className: a()("vi", {
          "vi--debug": m
        }),
        onKeyDown: function onKeyDown(e) {
          [l.ARROW_LEFT, l.ARROW_RIGHT, l.ARROW_UP, l.ARROW_DOWN].includes(e.keyCode) && e.preventDefault();
        },
        onFocus: function onFocus(e) {
          C(!0);
          var t = e.target.value;
          e.target.setSelectionRange(t.length, t.length), null == S || S();
        },
        onBlur: function onBlur() {
          C(!1), null == R || R();
        }
      }, _)), t().createElement("div", p({
        "data-testid": "container",
        className: a()("vi__container", O.container, {
          "vi__container--default": !b
        }),
        onClick: function onClick() {
          return I.current.focus();
        }
      }, A), (k = Array(i), function (e) {
        if (Array.isArray(e)) return v(e);
      }(k) || function (e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
      }(k) || h(k) || function () {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }()).map(function (e, n) {
        var r;
        return t().createElement("div", {
          className: a()("vi__character", O.character, (r = {
            "vi__character--default": !b,
            "vi__character--selected--default": !b && (N().length === n || N().length === n + 1 && i === n + 1) && T
          }, f(r, O.characterSelected, (N().length === n || N().length === n + 1 && i === n + 1) && T), f(r, "vi__character--inactive--default", !b && N().length < n), f(r, O.characterInactive, N().length < n), r)),
          onClick: W,
          id: "field-".concat(n),
          "data-testid": "character-".concat(n),
          key: n
        }, N()[n] || y);
      })), t().createElement("style", {
        dangerouslySetInnerHTML: {
          __html: u.Z
        }
      }));
    });
    y.displayName = "VerificationInput", y.propTypes = {
      value: c().string,
      length: c().number,
      validChars: c().string,
      placeholder: c().string,
      autoFocus: c().bool,
      removeDefaultStyles: c().bool,
      debug: c().bool,
      inputProps: c().object,
      classNames: c().shape({
        container: c().string,
        character: c().string,
        characterInactive: c().string,
        characterSelected: c().string
      }),
      onChange: c().func,
      onFocus: c().func,
      onBlur: c().func
    }, y.defaultProps = {
      length: 6,
      validChars: "A-Za-z0-9",
      placeholder: "·",
      autoFocus: !1,
      removeDefaultStyles: !1,
      debug: !1,
      inputProps: {},
      classNames: {}
    };
    var g = y;
  })(), module.exports = r;
})();